const $inject = ['$rootScope', '$scope', '$sce', 'authService', 'settingsService', 'AUTH_EVENTS', 'APP_CONFIG'];

const lbaAgentChatWidgetCtrl = function ($rootScope, $scope, $sce, authService, settingsService, AUTH_EVENTS, APP_CONFIG) {
  let vm = this;

  vm.WidgetState = 'icon'; // open-information, open-iframe
  vm.transitionState = transitionState;
  vm.IsEnabled = false;
  vm.DebtorSupportInformation = {
    Phone: '',
    Email: '',
  };
  vm.SupportInformation = {
    Phone: '',
    Email: '',
  };

  function transitionState(state) {
    switch (state) {
      case 'icon':
        vm.title = 'Contact Information';
        vm.IFrameClass = 'widget_IFrame_hidden';

        settingsService.getAny().then((settings) => {
          // 24 is the agent chat feature id.
          vm.feature = settings.AllowedFeatures.filter((f) => f.Id == 24)[0] || null;

          if (!!vm.feature) {
            vm.IFrameSrc = $sce.trustAsResourceUrl(vm.feature.Url);
          }

          if (!!settings.DebtorSupport) {
            vm.DebtorSupportInformation.Phone = settings.DebtorSupport.Phone;
            vm.DebtorSupportInformation.Email = settings.DebtorSupport.Email;
          }

          if (!!settings.SupportInformation) {
            vm.SupportInformation.Phone = settings.SupportInformation.Phone;
            vm.SupportInformation.Email = settings.SupportInformation.Email;
          }

          vm.IsEnabled =
            vm.IsAuthenticated &&
            (!!vm.feature ||
              !!vm.SupportInformation.Phone ||
              !!vm.SupportInformation.Email ||
              !!vm.DebtorSupportInformation.Phone ||
              !!vm.DebtorSupportInformation.Email);
        });
        break;

      case 'open-information':
        break;

      case 'open-iframe':
        vm.title = 'Agent Chat';
        vm.IFrameClass = 'widget_IFrame_visible';
        break;

      default:
        break;
    }

    vm.WidgetState = state;
  }

  $rootScope.$on(AUTH_EVENTS.logoutSuccess, () => {
    vm.IsEnabled = false;
    vm.IsAuthenticated = false;
  });
  $rootScope.$on(AUTH_EVENTS.loginSuccess, () => {
    vm.IsAuthenticated = true;
    vm.transitionState('icon');
  });

  vm.IsAuthenticated = authService.isAuthenticated();

  if (vm.IsAuthenticated) {
    vm.transitionState('icon');
  }
};

lbaAgentChatWidgetCtrl.$inject = $inject;

export default lbaAgentChatWidgetCtrl;



// WEBPACK FOOTER //
// ./src/components/lbAgentChatWidget/lbAgentChatWidgetCtrl.js